import React from 'react';
import { motion } from 'framer-motion';
import { Lightbulb } from 'lucide-react';
export function BikeStorySection() {
  return <section className="py-12 md:py-16 bg-amber-50/50 text-navy" data-id="element-17">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-18">
        <div className="text-center mb-8" data-id="element-19">
          <h2 className="text-3xl font-bold mb-6 text-gold-600" data-id="element-20">
            LA HISTORIA QUE LO CAMBIA TODO
          </h2>
        </div>

        <div className="bg-white border border-slate-100 rounded-3xl p-8 mb-8 text-center shadow-sm" data-id="element-21">
          <p className="text-lg text-slate-600 leading-relaxed mb-4" data-id="element-22">
            Nadie espera que un niño escriba una novela antes de aprender las
            letras. Nadie espera que corra antes de aprender a caminar.
          </p>
          <p className="text-xl font-bold text-gold-600" data-id="element-23">
            La lectura funciona exactamente igual.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gold/10 text-navy rounded-2xl p-6 shadow-sm border border-gold/20 flex items-start gap-4" data-id="element-24">
          <Lightbulb className="w-8 h-8 flex-shrink-0 mt-1" data-id="element-25" />
          <div data-id="element-26">
            <p className="font-bold mb-2" data-id="element-27">
              Primero aprende sonidos. Después sílabas. Después palabras.
              Después frases. Después historias completas.
            </p>
            <p className="text-sm text-slate-700" data-id="element-28">
              Mis Primeras Lecturas fue diseñado para respetar ese orden
              natural. Sin presión. Sin frustración. Sin improvisar.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}